import type { CategoryGroupEntity } from '@actual-app/core/types/models';

import { GRUPOS_FABRICA } from './escribir';

/** Lo que mira `useRecuperarTravesia` del barco abierto. */
export type BarcoAbierto = {
  grupos: readonly Pick<CategoryGroupEntity, 'id' | 'name' | 'is_income'>[];
  cuentas: number;
  movimientos: number;
};

/**
 * ¿Es un barco recién botado al que no le llegó la marca de la travesía?
 * Pasa si la creación se cortó antes de guardar la pref `travesia` (le
 * pasó a una persona nueva en iPhone, 16-oct-2026): el barco queda con las
 * categorías de fábrica en inglés y sin tutorial. Se reconoce porque tiene
 * los grupos de gasto de fábrica y nada más: ningún grupo propio, ni
 * cuentas, ni movimientos. Lo importado de YNAB o la demo traen cuentas y
 * movimientos, así que no entran.
 */
export function barcoSinEstrenar({
  grupos,
  cuentas,
  movimientos,
}: BarcoAbierto): boolean {
  if (cuentas > 0 || movimientos > 0) {
    return false;
  }
  const gasto = grupos.filter(g => !g.is_income);
  const deFabrica = (g: (typeof gasto)[number]) =>
    GRUPOS_FABRICA.some(f => f.id === g.id);
  return gasto.length > 0 && gasto.every(deFabrica);
}
